export default {
  'auth.error.generic': 'Operation failed. Please try again later.',
  'auth.error.captcha.tooFrequent': 'Verification code sent too frequently. Please try again later.',
  'auth.error.captcha.dailyLimit':
    'Daily verification code limit reached. Please try again tomorrow.',
};
